module.exports = __webpack_public_path__ + "img/f1.687865a0.jpg";